import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HoverScaleIconButton = styled(IconButton)(({ theme }) => ({
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    transform: 'scale(1.1)',
  },
}));
